import {createEntityAdapter} from '@reduxjs/toolkit'
import {IBill} from '../../types'

export const billsAdapter = createEntityAdapter<IBill>()